<div class="flex-control flex-column">
  <app-tabs>
    <li (click)="tabs_service.deactivate_tab()" [class.active]="!tabs_service.is_active()">Reminders</li>
  </app-tabs>
  <app-reminders-listing class="flex-control flex-column" [hidden]="tabs_service.is_active()"></app-reminders-listing>
</div>
